export default {
    pageName: 'ประวัติการลงเวลา',
    tab: {
        attendance: ' การลงเวลา ',
        quota: 'สิทธิคงเหลือ'
    },
    year: 'ปี',
    header: {
        type: 'ประเภท',
        quota: 'สิทธิคงเหลือ'
    }
}
